import { render, staticRenderFns } from "./LevelConfirmation.vue?vue&type=template&id=6c85b44b&"
import script from "./LevelConfirmation.vue?vue&type=script&lang=js&"
export * from "./LevelConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports